import { randomBytes } from 'crypto';

export const generateTraceId = (): string => {
  // Generate 16 random bytes (128 bits)
  const buffer = randomBytes(16);
  const traceId = buffer.toString('hex');

  // Make sure traceId is NOT all zeros (extremely unlikely)
  if (traceId === '00000000000000000000000000000000') {
    // Regenerate if this edge case happens
    return generateTraceId();
  }

  return traceId;
};

const generateSpanId = () => randomBytes(8).toString('hex');

export function createTraceparent(traceId: string, traceFlags: string = '01') {
  const parentId = generateSpanId();

  return `00-${traceId}-${parentId}-${traceFlags}`;
}

export function getOpenTelemetryTraceIdFromTraceparent(traceparent: string): string {
  const match = traceparent.match(/^00-([0-9a-f]{32})-[0-9a-f]{16}-[0-9a-f]{2}$/);
  return match ? match[1] : traceparent;
}
